import { render, staticRenderFns } from "./newviews_mobile.vue?vue&type=template&id=8d236742&scoped=true&"
import script from "./newviews_mobile.vue?vue&type=script&lang=js&"
export * from "./newviews_mobile.vue?vue&type=script&lang=js&"
import style0 from "./newviews_mobile.vue?vue&type=style&index=0&id=8d236742&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d236742",
  null
  
)

export default component.exports